import { useLocation, useNavigate, useParams } from "react-router-dom";

// react-router-dom v6+ dropped withRouter; this shim keeps the
// props.history.push/replace call sites working unchanged.
export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
        {...props}
        history={{
          push: (to, state) => navigate(to, { state }),
          replace: (to, state) => navigate(to, { replace: true, state }),
          goBack: () => navigate(-1),
        }}
        location={location}
        match={{ params }}
      />
    );
  }
  return ComponentWithRouterProp;
}

export default withRouter;
